@if (hasSingleSelectedOrderLine()) {
  <div>
    <div class="table-responsive label-selector-table">
      <table class="qty-table">
        @for (sizeSystem of orderLines[0].sizeSystems; track sizeSystem) {
          <tbody>
            <tr>
              <td [attr.rowspan]="getSizeRangeRowspan()" class="print-size-range-label-cell">{{ sizeSystem.name }}</td>
              <td>&nbsp;</td>
              @for (stockMovement of sizeSystem.stockMovements; track stockMovement) {
                <td class="print-size-label-header-cell">
                  @if (hasGtinOrSku(orderLines[0], stockMovement)) {
                    {{ stockMovement.sizeLabel }}
                  }
                </td>
              }
            </tr>
            <tr>
              <td class="print-selector-header-cell">{{ 'App_LabelType' | translate }}</td>
              @for (stockMovement of sizeSystem.stockMovements; track stockMovement) {
                <td class="print-selector-cell">
                  @if (hasGtinOrSku(orderLines[0], stockMovement)) {
                    <dx-number-box id="sizeLabel"
                      class="print-selector"
                      [min]="0"
                      [max]="usingRfid ? getTotalItems(stockMovement, orderLines[0]) : undefined"
                      [disabled]="getTotalItems(stockMovement, orderLines[0]) === 0"
                      [showSpinButtons]="true"
                      [value]="getTotalLabelsToPrint(stockMovement, orderLines[0])"
                      (onValueChanged)="updateTotalLabelsToPrint(stockMovement, orderLines[0], $event)">
                    </dx-number-box>
                  }
                </td>
              }
            </tr>
            <tr>
              <td class="print-summary-header-cell">
                @if (getOrderType() === 'twostep') {
                  {{ 'App_Planned' | translate }}
                }
                @if (getOrderType() === 'onestep') {
                  {{ 'App_Received' | translate }}
                }
              </td>
              @for (stockMovement of sizeSystem.stockMovements; track stockMovement) {
                <td class="print-summary-cell">
            <span [ngClass]="{ 'delivery-details-received-qty': allItemsHaveBeenReceived(stockMovement),
                               'delivery-details-receiving-qty': !allItemsHaveBeenReceived(stockMovement) }">
                    @if (getOrderType() === 'twostep') {
                      {{ getOrderedQty(stockMovement, orderLines[0]) || '&nbsp;' }}
                    }
                    @if (getOrderType() === 'onestep') {
                      {{ getTotalItems(stockMovement, orderLines[0]) || '&nbsp;' }}
                    }
                  </span>
                </td>
              }
            </tr>
            @if (getOrderType() === 'twostep') {
              <tr>
                <td class="print-summary-header-cell">{{ 'App_Received' | translate }}</td>
                @for (stockMovement of sizeSystem.stockMovements; track stockMovement) {
                  <td class="print-summary-cell">
                    @if (getOrderedQty(stockMovement, orderLines[0]) > 0) {
                      {{ getReceivedQty(stockMovement, orderLines[0]) }}
                    } @else {
                      &nbsp;
                    }
                  </td>
                }
              </tr>
            }
            @if (getOrderType() === 'twostep') {
              <tr>
                <td class="print-summary-header-cell">{{ 'App_AlreadyPrinted' | translate }}</td>
                @for (stockMovement of sizeSystem.stockMovements; track stockMovement) {
                  <td class="print-summary-cell">
                    @if (getOrderedQty(stockMovement, orderLines[0]) > 0) {
                      {{ getAlreadyPrintedQty(stockMovement, orderLines[0]) }}
                    } @else {
                      &nbsp;
                    }
                  </td>
                }
              </tr>
            }
            @if (usingRfid) {
              <tr>
                <td class="print-summary-header-cell">{{ 'App_Unprinted' | translate }}</td>
                @for (stockMovement of sizeSystem.stockMovements; track stockMovement) {
                  <td class="print-summary-cell">
                    {{ getTotalUnprintedLabels(stockMovement, orderLines[0]) || '&nbsp;' }}
                  </td>
                }
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  </div>
}
